import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';
import { CssSelectors } from '../../../../styles/styles';

const { colors, common, queries, spacing, typography } = THEME;

export const styleSheet = StyleSheet.create({
	closingDate: {
		alignItems: 'center',
		display: 'flex',
		gap: spacing.sm,
	},
	closingDateInput: {
		flex: 1,
		minWidth: 0,
	},
	column: {
		flex: 1,
		minWidth: 0,
		width: '100%',
	},
	columns: {
		alignItems: 'flex-start',
		display: 'flex',
		gap: spacing.lg,
		[queries.sm]: {
			flexDirection: 'column',
			gap: spacing.md,
		},
	},
	comboboxFooter: {
		borderTop: `1px solid ${colors.border.light}`,
		marginTop: spacing.xs,
		paddingTop: spacing.xs,
	},
	details: {
		...CssSelectors.allDescendants({
			color: colors.text.main,
		}),
	},
	detailsField: {
		border: common.border,
		borderRadius: common.borderRadius,
		maxHeight: 160,
		minHeight: 80,
		overflowY: 'auto',
		padding: spacing.sm,
	},
	field: {
		marginBottom: spacing.md,
	},
	fieldLabel: {
		color: colors.text.main,
		fontSize: typography.fontSizes.sm,
		fontWeight: typography.fontWeights.semibold,
		marginBottom: 6,
	},
	helperText: {
		color: colors.text.light,
		fontSize: typography.fontSizes.xs,
		lineHeight: 1.4,
		marginTop: 6,
	},
	loading: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
		minHeight: 240,
		width: '100%',
	},
	popup: {
		maxWidth: 'calc(100vw - 32px)',
		width: 660,
	},
	requiredMark: {
		color: colors.danger.main,
		marginLeft: 2,
	},
	selectStyles: {
		borderRadius: common.borderRadius,
		maxWidth: 'none',
		width: '100%',
	},
	tagsField: {
		alignItems: 'flex-start',
		border: common.border,
		borderRadius: common.borderRadius,
		display: 'flex',
		justifyContent: 'flex-start',
		minHeight: 44,
		padding: spacing.sm,
	},
});
